import axios from "axios";
import React from "react";
import { AuthContext } from "../AuthContext/Authcontext";

// //server
const API_URL = "https://backend.baghelscorporatepvtltd.com/api";
// const API_URL = "http://127.0.0.1:8000/api/";

const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Accept': 'application/json',
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Handle timeout/connection errors
    if (error.code === 'ECONNABORTED' || !error.response) {
      if (!originalRequest._retryCount) originalRequest._retryCount = 0;

      if (originalRequest._retryCount < 3) {
        originalRequest._retryCount += 1;
        await new Promise(resolve => setTimeout(resolve, 1000 * originalRequest._retryCount));
        return api(originalRequest);
      }
      return Promise.reject({
        message: 'Network error - please check your connection',
        isNetworkError: true
      });
    }

    // Handle 401 Unauthorized
    if (error.response.status === 401 && !originalRequest._retry) {
      // You can add token refresh logic here if needed

      // For now, just logout
      if (typeof window !== 'undefined') {
        const authContext = React.useContext(AuthContext);
        if (authContext && authContext.logout) {
          authContext.logout();
        }
      }

      return Promise.reject({
        message: 'Session expired - please login again',
        isAuthError: true
      });
    }

    // Handle other errors
    return Promise.reject({
      message: error.response.data?.message || 'An error occurred',
      status: error.response.status,
      data: error.response.data,
      isServerError: true
    });
  }
);

export default api;